type MinicartSideBarContentWrapperProps = { children: React.ReactNode };

const MinicartSideBarContentWrapper = ({ children }: MinicartSideBarContentWrapperProps) => {
	return (
		<div className={`vtex-minicart-2-x-minicartSideBarContentWrapper flex flex-column w-100 h-100`}>
			<div className="vtex-minicart-2-x-minicartContentContainer vtex-minicart-2-x-drawerStyles flex flex-column justify-between">
				<h3 className="vtex-minicart-2-x-minicartTitle t-heading-3 mv2 ph4 ph6-l c-on-base">Carrinho</h3>
				<div className="vtex-minicart-2-x-minicartProductListContainer w-100 h-100 overflow-y-auto ph4 ph6-l">
					<div>
						<div className="vtex-flex-layout-0-x-flexRow">
							<div className="flex mt0 mb0 pt5 pb6    justify-start justify-between vtex-flex-layout-0-x-flexRowContent items-stretch w-100">
								<div
									className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth   flex"
									style={{ width: 'auto' }}
								>
									<div className="vtex-flex-layout-0-x-flexCol  ml0 mr5 pl0 pr0      flex flex-column h-100 w-100">
										<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: '100%' }}>
											<div
												id="image-85"
												className="vtex-product-list-0-x-productImageContainer "
												style={{ width: '96px' }}
											>
												<a
													className="vtex-product-list-0-x-productImageAnchor"
													href="/tapioqueira-e-panquequeira-eletrica----cadence-27149/p"
												>
													<img
														className="vtex-product-list-0-x-productImage br2 vtex-render-runtime-8-x-lazyload ls-is-cached lazyloaded"
														loading="lazy"
														alt="Tapioqueira E Panquequeira Elétrica  - Cadence"
														width="100%"
														data-src="https://maeztra.vtexassets.com/arquivos/ids/155560-96-auto"
														src="https://maeztra.vtexassets.com/arquivos/ids/155560-96-auto"
													/>
												</a>
											</div>
										</div>
									</div>
								</div>
								<div className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth flex-grow-1  flex">
									<div className="vtex-flex-layout-0-x-flexCol  ml0 mr0 pl0 pr0      flex flex-column h-100 w-100">
										<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: '100%' }}>
											<div className="vtex-flex-layout-0-x-flexRow">
												<div className="flex mt0 mb0 pt0 pb0    justify-start justify-between vtex-flex-layout-0-x-flexRowContent items-stretch w-100">
													<div className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth flex-grow-1  flex">
														<div className="vtex-flex-layout-0-x-flexCol  ml0 mr0 pl0 pr0      flex flex-column h-100 w-100">
															<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: 'auto' }}>
																<div className="vtex-flex-layout-0-x-flexRow">
																	<div className="flex mt0 mb2 pt0 pb0    justify-start  vtex-flex-layout-0-x-flexRowContent items-stretch w-100">
																		<div
																			className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth   flex"
																			style={{ width: '100%' }}
																		>
																			<div
																				id="brand-name-85"
																				className="ttu f7 fw6 c-muted-1 fw5-m vtex-product-list-0-x-productBrandName "
																			>
																				Test Brand name
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: 'auto' }}>
																<div className="vtex-flex-layout-0-x-flexRow">
																	<div className="flex mt0 mb0 pt0 pb0    justify-start  vtex-flex-layout-0-x-flexRowContent items-stretch w-100">
																		<div
																			className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth   flex"
																			style={{ width: '100%' }}
																		>
																			<a
																				id="name-85"
																				className="c-on-base t-title lh-copy fw6 no-underline fw5-m vtex-product-list-0-x-productName "
																				href="/tapioqueira-e-panquequeira-eletrica----cadence-27149/p"
																			>
																				Tapioqueira E Panquequeira Elétrica - Cadence
																			</a>
																		</div>
																	</div>
																</div>
															</div>
															<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: 'auto' }}>
																<div className="vtex-flex-layout-0-x-flexRow">
																	<div className="flex mt2 mb0 pt0 pb0    justify-start  vtex-flex-layout-0-x-flexRowContent items-stretch w-100">
																		<div
																			className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth   flex"
																			style={{ width: '100%' }}
																		></div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div
														className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth   flex"
														style={{ width: 'auto' }}
													>
														<div className="vtex-flex-layout-0-x-flexCol  ml3 mr0 pl0 pr0      flex flex-column h-100 w-100">
															<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: '100%' }}>
																<div className="vtex-product-list-0-x-removeButtonContainer vtex-product-list-0-x-item ">
																	<button
																		id="remove-button-85"
																		className="vtex-product-list-0-x-removeButton pointer bg-transparent bn pa2"
																		title="remove"
																		style={{ color: 'rgb(114, 114, 115)' }}
																	>
																		<svg
																			fill="none"
																			width="16"
																			height="16"
																			viewBox="0 0 16 16"
																			className=" vtex-product-list-0-x-deleteIcon"
																			xmlns="http://www.w3.org/2000/svg"
																		>
																			<use href="#hpa-delete"></use>
																		</svg>
																	</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: '100%' }}>
											<div className="vtex-flex-layout-0-x-flexRow">
												<div className="flex mt5 mb0 pt0 pb0    justify-start  vtex-flex-layout-0-x-flexRowContent items-stretch w-100">
													<div className="pr0 items-stretch    flex" style={{ width: 'auto' }}>
														<div className="vtex-product-list-0-x-quantitySelectorContainer vtex-product-list-0-x-quantity vtex-product-list-0-x-quantitySelector">
															<div className="vtex-product-list-0-x-quantityDropdownMobileContainer dn-m">
																<div
																	className="vtex-styleguide-9-x-dropdown vtex-dropdown"
																	data-testid="quantity-dropdown-mobile-85"
																>
																	<label className="h-100">
																		<div className="vtex-styleguide-9-x-container vtex-dropdown__container br2 relative bw1 bg-base ba h-small hover-b--muted-3 b--muted-4">
																			<div
																				id="quantity-dropdown-mobile-85"
																				className="vtex-dropdown__button bg-transparent bn w-100 h-100 pl5 pr3 pointer c-on-base"
																			>
																				<div className="flex h-100">
																					<div className="vtex-dropdown__caption flex-auto tl truncate h-100">
																						<div className="h-100 flex items-center">1 </div>
																					</div>
																					<div className="vtex-dropdown__arrow flex-none flex items-center pl2 c-action-primary">
																						<svg
																							xmlns="http://www.w3.org/2000/svg"
																							width="18"
																							height="18"
																							viewBox="0 0 24 24"
																						>
																							<g fill="currentColor">
																								<path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path>
																							</g>
																						</svg>
																					</div>
																				</div>
																			</div>
																			<select
																				className="o-0 absolute top-0 left-0 h-100 w-100 bottom-0 t-body pointer"
																				style={{
																					appearance: 'menulist-button',
																				}}
																			>
																				<option value=""> </option>
																				<option value="0">0 - Remover</option>
																				<option value="1">1 </option>
																				<option value="2">2 </option>
																				<option value="3">3 </option>
																				<option value="4">4 </option>
																				<option value="5">5 </option>
																				<option value="6">6 </option>
																				<option value="7">7 </option>
																				<option value="8">8 </option>
																				<option value="9">9 </option>
																				<option value="10">10 +</option>
																			</select>
																		</div>
																	</label>
																</div>
															</div>
															<div className="vtex-product-list-0-x-quantityDropdownContainer dn db-m">
																<div
																	className="vtex-styleguide-9-x-dropdown vtex-dropdown"
																	data-testid="quantity-dropdown-85"
																>
																	<label className="h-100">
																		<div className="vtex-styleguide-9-x-container vtex-dropdown__container br2 relative bw1 bg-base ba h-regular hover-b--muted-3 b--muted-4 t-body">
																			<div
																				id="quantity-dropdown-85"
																				className="vtex-dropdown__button bg-transparent bn w-100 h-100 pl5 pr3 pointer c-on-base"
																			>
																				<div className="flex h-100">
																					<div className="vtex-dropdown__caption flex-auto tl truncate h-100">
																						<div className="h-100 flex items-center">1 </div>
																					</div>
																					<div className="vtex-dropdown__arrow flex-none flex items-center pl2 c-action-primary">
																						<svg
																							xmlns="http://www.w3.org/2000/svg"
																							width="18"
																							height="18"
																							viewBox="0 0 24 24"
																						>
																							<g fill="currentColor">
																								<path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path>
																							</g>
																						</svg>
																					</div>
																				</div>
																			</div>
																			<select
																				className="o-0 absolute top-0 left-0 h-100 w-100 bottom-0 t-body pointer"
																				style={{
																					appearance: 'menulist-button',
																				}}
																			>
																				<option value=""> </option>
																				<option value="0">0 - Remover</option>
																				<option value="1">1 </option>
																				<option value="2">2 </option>
																				<option value="3">3 </option>
																				<option value="4">4 </option>
																				<option value="5">5 </option>
																				<option value="6">6 </option>
																				<option value="7">7 </option>
																				<option value="8">8 </option>
																				<option value="9">9 </option>
																				<option value="10">10 +</option>
																			</select>
																		</div>
																	</label>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: '100%' }}>
											<div className="vtex-flex-layout-0-x-flexRow">
												<div className="flex mt3 mb0 pt0 pb0    justify-start  vtex-flex-layout-0-x-flexRowContent items-stretch w-100">
													<div
														className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth   flex"
														style={{ width: '100%' }}
													></div>
												</div>
											</div>
										</div>
										<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: '100%' }}>
											<div className="vtex-flex-layout-0-x-flexRow">
												<div className="flex mt5 mb0 pt0 pb0    justify-start  vtex-flex-layout-0-x-flexRowContent items-stretch w-100">
													<div className="pr0 items-stretch    flex" style={{ width: 'auto' }}>
														<div className=" vtex-product-list-0-x-price vtex-product-list-0-x-productPriceContainer tl">
															<div id="price-85" className="vtex-product-list-0-x-productPrice div fw6 fw5-m">
																<div className="vtex-product-list-0-x-price">R$&nbsp;200,00</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: '100%' }}>
											<div className="vtex-flex-layout-0-x-flexRow">
												<div className="flex mt3 mb0 pt0 pb0    justify-start  vtex-flex-layout-0-x-flexRowContent items-stretch w-100">
													<div
														className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth   flex"
														style={{ width: '100%' }}
													></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="vtex-flex-layout-0-x-flexRow vtex-flex-layout-0-x-flexRow--minicart-footer">
					<div className="flex mt0 mb0 pt0 pb0    justify-start  vtex-flex-layout-0-x-flexRowContent vtex-flex-layout-0-x-flexRowContent--minicart-footer items-stretch w-100">
						<div
							className="pr0 items-stretch vtex-flex-layout-0-x-stretchChildrenWidth   flex"
							style={{ width: '100%' }}
						>
							<div className="vtex-flex-layout-0-x-flexCol  ml0 mr0 pl0 pr0      flex flex-column h-100 w-100">
								<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: '100%' }}>
									<div className="vtex-minicart-2-x-minicartSummary ph4 ph6-l pt5">
										<div className="vtex-checkout-summary-0-x-summarySmallContent c-on-base">
											<div className="flex w-100 c-on-base lh-copy items-center vtex-checkout-summary-0-x-summaryItemContainer mt3">
												<div id="items" className="vtex-checkout-summary-0-x-summaryItemLabel flex-none fw6 fw5-l">
													Subtotal
												</div>
												<div id="items-price" className="flex-auto tr vtex-checkout-summary-0-x-summaryItemPrice ">
													<div className="vtex-checkout-summary-0-x-price">R$&nbsp;200,00</div>
												</div>
											</div>
											<div className="flex w-100 c-on-base lh-copy items-center vtex-checkout-summary-0-x-summaryItemContainer f4 mt4 pb5">
												<div id="total" className="vtex-checkout-summary-0-x-summaryItemLabel flex-none fw6 fw5-l">
													Total
												</div>
												<div
													id="total-price"
													className="flex-auto tr vtex-checkout-summary-0-x-summaryItemPrice fw6 fw5-l"
												>
													<div className="vtex-checkout-summary-0-x-price">R$&nbsp;200,00</div>
												</div>
											</div>
										</div>
										<span className="vtex-checkout-summary-0-x-summarySmallDisclaimer t-small db mv4">
											Taxas e frete calculados no Carrinho
										</span>
									</div>
								</div>
								<div className="vtex-flex-layout-0-x-flexColChild pb0" style={{ height: '100%' }}>
									<div className="vtex-minicart-2-x-minicartCheckoutButton mv3 ph4 ph6-l">
										<button
											id="proceed-to-checkout"
											tabIndex={0}
											className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-regular t-action bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary pointer w-100 "
											type="button"
										>
											<div
												className="vtex-button__label flex items-center justify-center h-100 ph6 w-100 border-box "
												style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
											>
												Ir para o checkout
											</div>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MinicartSideBarContentWrapper;
